<template>
  <div class="rules">
    <table border="0" cellspacing="0" cellpadding="0">
      <thead>
      <tr>
        <th>奖励行为</th>
        <th>奖励值</th>
        <th>每日奖励上限</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in info" :key="index">
        <td>{{item.name}}</td>
        <td>{{item.points}}</td>
        <td>{{item.day_num}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        info: {}
      }
    },
    created () {
      this.getpointsrule()
    },
    methods: {
      getpointsrule () {
        this.$http.post('/apipx/Personal/pointsrule', {
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .rules {
    padding: 35px;
    background-color: #fff;
    border-radius: 35px;
    box-shadow: 0px 0px 20px #e2e0e0;

    table {
      width: 820px;

      thead {
        th {
          height: 60px;
          line-height: 60px;
          text-align: left;
          text-indent: 35px;
        }
      }

      tbody {
        tr {

          &:nth-last-of-type(odd) {
            background-color: #fff9f8;
          }

          td {
            height: 60px;
            line-height: 60px;
            text-align: left;
            text-indent: 35px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/integral/rules/rules.vue